import UserReport from '@/models/UserReport'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    reportDetails: []
  },

  mutations: {
    setReportsList(state, reports) {
      each(reports, report => {
        const exist = find(state.list, { id: report.id })
        if (!exist) {
          state.list.push(new UserReport(report))
        }
      })
    },

    clearReportsList(state) {
      state.list = []
    },

    setReportsListMeta(state, meta) {
      state.listMeta = meta
    },

    setReportDetails(state, report) {
      if (report instanceof UserReport) {
        state.reportDetails = report
      } else {
        state.reportDetails = new UserReport(report)
      }
    },

    clearReportDetails(state) {
      state.list = []
    }
  },

  actions: {
    async getReports({ commit }, params) {
      try {
        const query = UserReport.page(params.page || 1)

        query.where('reportable_type', params.reportable_type)

        if (params.search) {
          query.where('search', params.search)
        }

        const res = await query
          .params({ limit: 20 })
          .include('reporter', 'reason')
          .get()

        commit('setReportsList', res.data)
        commit('setReportsListMeta', res.meta)
      } catch (error) {}
    },

    async getReportDetails({ commit }, reportId) {
      try {
        const { data } = await Api.get(
          `/admin/user/report/${reportId}?include=reason,reporter,attachments,reportable`
        )

        commit('setReportDetails', data.data)
      } catch (error) {}
    }
  }
}
